import { render, staticRenderFns } from "./TransferStats.vue?vue&type=template&id=6d54b790&scoped=true"
import script from "./TransferStats.vue?vue&type=script&lang=js"
export * from "./TransferStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d54b790",
  null
  
)

export default component.exports